import { ArrowUpRight } from "lucide-react"
import type { ReactNode } from "react"

type PageHeaderProps = {
  title: string
  description?: string
  /** Optional glyph rendered immediately left of the title (e.g. a marketplace mark). */
  icon?: ReactNode
  /** When set, the whole title becomes a link that opens this URL in a new tab. */
  titleHref?: string
  actions?: ReactNode
}

export function PageHeader({ title, description, icon, titleHref, actions }: PageHeaderProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="min-w-0">
        {titleHref ? (
          <a
            href={titleHref}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-2.5 rounded-md outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          >
            {icon}

            <h1 className="text-2xl font-semibold tracking-tight text-foreground underline-offset-4 group-hover:underline">
              {title}
            </h1>

            <ArrowUpRight className="size-4 text-muted-foreground/50 transition-all group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-foreground" />
          </a>
        ) : (
          <div className="flex items-center gap-2.5">
            {icon}

            <h1 className="text-2xl font-semibold tracking-tight text-foreground">{title}</h1>
          </div>
        )}

        {description ? (
          <p className="mt-1.5 max-w-2xl text-sm text-muted-foreground">{description}</p>
        ) : null}
      </div>

      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  )
}
